export default {
  vehicle: {
    detail: '车辆详情'
  },
  placeholder: {
    device_name: '设备名称',
    data_name: '数据名称'
  }
}
